import * as React from "react";
import {Line} from "react-chartjs-2";
import 'chartjs-plugin-colorschemes';
import {formatEuroValue} from "../reactUtils";

export default class MieteinnahmenPerMonthChart extends React.Component {

    chartOptions = {
        plugins: {
            colorschemes: {
                scheme: "brewer.DarkTwo8"
            }
        },

        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: false,
                    callback: function(value, index, values) {
                        return formatEuroValue(value, true);
                    }
                }
            }],
        },
        title: {
            display:true,
            text: "Mieteinnahmen pro Monat",
            fontSize: 20
        },
        tooltips: {
            callbacks: {
                label: function(tooltipItem, data) {
                    data = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                    return formatEuroValue(data);
                }
            }
        }
    };

    render() {
        let data = this.props.data;
        return (
            <Line data={data} options={this.chartOptions}/>
        );
    }
}